import { jsx as _jsx } from "react/jsx-runtime";
import Slider from '@shared/Slider/Slider';
import classes from './Services.module.scss';
import ServiceCard from './ServiceCard/ServiceCard';
import classNames from 'classnames';
import { useWindowSize } from '@hooks/useWindowSize';
import { useSelector } from 'react-redux';
import { kionStatusSelector, netariffSelector, subscriptionSelector, subscriptionStatusSelector, tariffPlanSelector, } from '@models/subscription/selectors';
import { childThemeSelector, childUserSelector } from '@store/models/user/selectors';
import { useTypedDispatch } from '@hooks/useTypedDispatch';
import { triggerMetricsEvent } from '@metrics';
import { useNavigate } from 'react-router';
import { getInstructionUrl } from '@utils/getInstructionUrl';
import { partnersForParent, partnersForChild, partnersChildVersion } from '@configs/partners';
import { moreCardList } from '@configs/more';
import { TariffPlanEnum } from '@store/models/subscription/types';
const maxControlsShownWidth = 1200;
const partnersList = {
    parent: [...partnersForParent, ...partnersForChild],
    child: partnersChildVersion,
};
const Services = () => {
    const { isMTSSubscriber } = useSelector(subscriptionSelector);
    const isChildAuth = useSelector(childUserSelector);
    const isChild = useSelector(childThemeSelector);
    const tariffPlan = useSelector(tariffPlanSelector);
    const version = isChildAuth ? 'child' : 'parent';
    const subscriptionStatus = useSelector(subscriptionStatusSelector);
    const kionStatus = useSelector(kionStatusSelector);
    const navigate = useNavigate();
    const isNetariff = useSelector(netariffSelector);
    const { dialogModel: { openMoreElDialog }, } = useTypedDispatch();
    const handleIncludesClick = (cardName, serviceName) => () => {
        triggerMetricsEvent({ element: serviceName });
        const url = getInstructionUrl(cardName, isChild);
        navigate(url);
    };
    const handleMoreClick = (cardName, serviceName) => () => {
        openMoreElDialog(cardName);
        triggerMetricsEvent({ element: serviceName });
    };
    const getCards = () => {
        const isYearTariff = tariffPlan === TariffPlanEnum.Year;
        const includesList = partnersList[version].filter(({ name }) => !((!isYearTariff || isNetariff) && name === 'leoni') && name !== 'launcher');
        const includesCards = includesList.map(include => (_jsx(ServiceCard, { data: include, subscriptionStatus: subscriptionStatus, kionStatus: kionStatus, onClick: handleIncludesClick(include.name, include.serviceName) }, include.id)));
        const moreCards = isMTSSubscriber
            ? moreCardList[version].map(more => (_jsx(ServiceCard, { data: more, subscriptionStatus: subscriptionStatus, onClick: handleMoreClick(more.name, more.serviceName) }, more.id)))
            : [];
        return [...includesCards, ...moreCards];
    };
    const { width, isDesktop } = useWindowSize();
    const isResponsiveWidth = width >= maxControlsShownWidth;
    const isControlsHidden = !isDesktop || (!isMTSSubscriber && isResponsiveWidth);
    const controlsClasses = classNames(classes.sliderControls, { [classes.controlsHidden]: isControlsHidden });
    const handleScroll = () => triggerMetricsEvent({ element: 'subscriptionCardsScroll' });
    return (_jsx(Slider, { className: classes.slider, slideClass: classes.slide, progressbar: true, navigation: true, controlsClass: controlsClasses, progressbarClass: classes.progressbar, navigationButtonClass: classes.navButton, onScroll: handleScroll, children: getCards() }));
};
export default Services;
